import AmazingOffers from './AmazingOffers';

export default AmazingOffers;
